import Service, {IService} from "@/model/Service/Service"
import hasTotalPrice, { IHasTotalPrice } from "@/model/mixins/Price/hasTotalPrice"
import hasCrossPrice, { IHasCrossPrice } from "@/model/mixins/Price/hasCrossPrice"
import hasTotalPriceByTravellerOrAccomodationId, {IHasTotalPriceByTravellerOrAccomodationId} from "@/model/mixins/Price/hasTotalPriceByTravellerOrAccomodationId"
import hasAccomodations, {IHasAccomodations} from "@/model/mixins/Accomodation/hasAccomodations"
import hasIncluded, {IHasIncluded} from "@/model/mixins/hasIncluded"

class AccomodationServiceBase extends Service {
    protected quantityMin: number
    protected quantityMax: number
    protected quantitySelected: number
    protected price: number
    constructor(
        quantityMin: number,
        quantityMax: number,
        quantitySelected: number,
        price: number,
        id: string,
        quantity?: number,
        startDate?: string,
        endDate?: string,
    ) {
        super(
            id,
            quantity,
            startDate,
            endDate,
        )
        this.quantityMin = quantityMin
        this.quantityMax = quantityMax
        this.quantitySelected = quantitySelected
        this.price = price
    }

    public getQuantityMin(): number {
        return this.quantityMin
    }
    public getQuantityMax(): number {
        return this.quantityMax
    }
    public getQuantitySelected(): number {
        return this.quantitySelected
    }
    public getPrice(): number {
        return this.price
    }

    getSelectedQuantity(): number {
        return this.getQuantitySelected()
    }

}

export interface IAccomodationService extends IService, IHasIncluded, IHasAccomodations, IHasTotalPriceByTravellerOrAccomodationId, IHasTotalPrice, IHasCrossPrice {
    getQuantityMin(): number
    getQuantityMax(): number
    getQuantitySelected(): number
    getPrice(): number
}


const AccomodationService: Constructor<IAccomodationService> = hasIncluded(hasCrossPrice(hasAccomodations(hasTotalPrice(hasTotalPriceByTravellerOrAccomodationId(AccomodationServiceBase)))))

export default AccomodationService